/**
 * Converts an array of objects into a record indexed by a specified key.
 *
 * @param {T[]} array - Array of objects
 * @param {K} key - Key as string from which to index by, must exist on T
 *
 * @return {Record<string, T>} Record indexed by the specified key
 *
 * @example
 * const data = [
 *   { id: 'a1', name: 'Item 1' },
 *   { id: 'b2', name: 'Item 2' },
 * ];
 * const record = arrayToRecordByKey(data, 'id');
 * // record = {
 * //   a1: { id: 'a1', name: 'Item 1' },
 * //   b2: { id: 'b2', name: 'Item 2' },
 * // }
 */
export const arrayToRecordByKey = <T extends Record<K, string>, K extends keyof T>(
  array: T[],
  key: K
): Record<T[K], T> => {
  return Object.fromEntries(array.map((item) => [item[key], item])) as Record<T[K], T>;
};
